<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmtitle1" id="page3">Military Balance</h2>
<p class="noindent">ILDF evaluation of the Egyptian expeditionary force in the HOREV sector was three regular brigades and nine reserve battalions; a force that was estimated at 10,000 to 13,000 soldiers. An EGDF brigade under siege at Faluja and Egyptian forces in Judea were not included in the ILDF evaluation of EGDF in the HOREV sector.</p>
<p class="indent">ILDF fielded 12 brigades divided between four fronts. Front D HOREV forces included five brigades, of which one faced the Faluja Pocket, one was assigned to a secondary effort against the Gaza Strip and three were assigned to the main effort in the direction of Auja.</p>
<p class="indent">ILAF evaluation of EGAF ORBAT was two Spitfire squadrons, two FIAT squadrons, one Stirling squadron and two transport squadrons.</p>
<div class="img_container">
<p class="imag"><img alt="image" src="images/p3-2.jpg"/></p>
<p class="caption">The ILAF changed its aircraft serial system in November 1948; the new serial system composed of four digits: the two left digits indicated type and the two right digits identified aircraft. Type 01 was Auster so 0115 was the 15th Auster in ILAF service at the time of new serial system introduction. Auster 0115 - reportedly photographed at St Jean, ILAF Flying School base, during December 1948 - was one of some 40 aircraft that were not assigned to frontline units at the start of HOREV; most of these aircraft were undergoing maintenance while others were awaiting disposal or assigned to the Flying School.</p>
</div>
<p class="indent">ILAF ORBAT included some 60 aircraft assigned to seven squadrons and one flight at five bases:</p>
<div class="img_container">
<p class="imag"><img alt="image" src="images/p3-3.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Military.vue?5b2bce1c